module.exports = __webpack_public_path__ + "media/images/icon__warning-dfe59756c0fdae7f581829f6d3e2f008.png";